export default "__VITE_ASSET__DcL0I2eB__"